import { apiClient } from './apiClient';

export interface ModelMetrics {
  requests: number;
  tokensConsumed: number;
  avgResponseTimeMs: number;
  p95ResponseTimeMs: number;
  failures: number;
}

export interface AIMetricsSnapshot {
  totalRequests: number;
  successfulRequests: number;
  failedRequests: number;
  rateLimitedRequests: number;
  retriedRequests: number;
  currentQueueDepth: number;
  retryQueueDepth: number;
  permanentFailures: number;
  analysis: ModelMetrics;
  summary: ModelMetrics;
  windowStart: string;
  snapshotTime: string;
}

export interface AIHealthStatus {
  status: 'healthy' | 'degraded' | 'unhealthy';
  failureRatePercent: number;
  analysisTpmUtilizationPercent: number;
  summaryTpmUtilizationPercent: number;
  reason: string;
  checkedAt: string;
}

export interface RateLimiterSnapshot {
  model: string;
  concurrentSlotsUsed: number;
  concurrentSlotsMax: number;
  requestsInLastMinute: number;
  maxRequestsPerMinute: number;
  rpmUtilizationPercent: number;
  tokensConsumedInLastMinute: number;
  maxTokensPerMinute: number;
  tpmUtilizationPercent: number;
  isPaused: boolean;
}

export interface SpeechApiRateLimitStatus {
  requestsInWindow: number;
  maxRequestsPerWindow: number;
  effectiveBudget: number;
  utilizationPercent: number;
  isPaused: boolean;
  pausedUntilUtc: string | null;
}

export interface ActionRecommendation {
  severity: 'info' | 'warning' | 'critical';
  category: string;
  message: string;
  action: string;
  settingKey: string;
}

export interface SystemHealthDashboard {
  health: AIHealthStatus;
  metrics: AIMetricsSnapshot;
  analysisRateLimiter: RateLimiterSnapshot;
  summaryRateLimiter: RateLimiterSnapshot;
  speechRateLimiter: SpeechApiRateLimitStatus;
  tenantFailures: Record<string, number>;
  recommendations: ActionRecommendation[];
}

class SystemHealthService {
  async getDashboard(): Promise<SystemHealthDashboard> {
    const response = await apiClient.get('/api/ai-metrics/dashboard');
    return response.data;
  }
}

export const systemHealthService = new SystemHealthService();
